<div class="overlay-bg"></div>
<div class="col-md-3 left_col">
  <div class="sticky-left-bar d-none"></div>
<!--<app-sidebar start>-->  
    <div  class="left_col scroll-view">  
        <div class="clearfix"></div>

        <div class="profile clearfix">
          <div class="profile_pic">
            <!-- <a routerLink="/userprofile"><img src="{{profilePicture}}" alt="menu_profile-pic" class="img-circle profile_img"></a> -->
          </div>
          <div class="profile_info">
            <span>Minutes of Meeting</span>
          </div>
        </div> 
<!-- sidebar menu -->
<div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
  
    <div class="menu_section">
      <ul class="nav side-menu">
        <li [routerLinkActive]="['active']" (click)="SubmenuShow1 = !SubmenuShow1;SubmenuShow5=false;">
          <a routerLink="/dashboard"><img class="img-fluid pr-1" src="\assets\v2\img\home-icon.png" alt="Dashboard" /> Dashboard <span class="d-none">Dashboard</span></a>
        </li>
        <li [routerLinkActive]="['current-page']" (click)="SubmenuShow1 = !SubmenuShow1;SubmenuShow5=false;">
          <a routerLink="/meetingofminutes"><!--<i class="las la-chess-king"></i>--><img class="img-fluid pr-1" src="\assets\v2\img\mom-icon.png" alt="Mom" /> Minutes of Meeting  <span class="d-none">Minutes&nbsp;of&nbsp;Meeting</span></a>
        </li>
        <li [routerLinkActive]="['active']" (click)="SubmenuShow3 = !SubmenuShow3;SubmenuShow5=false;">
          <a routerLink="/meetingaction"><!--<i class="las la-chalkboard"></i>--><img class="img-fluid pr-1" src="\assets\v2\img\mom-action.png" alt="Action Points" /> Action Points  <span class="d-none">Action&nbsp;Points</span></a>
        </li>
        <li [routerLinkActive]="['active']" (click)="SubmenuShow4 = !SubmenuShow4;SubmenuShow5=false;">
          <a routerLink="/digitalattendance"><!--<i class="las la-chart-bar"></i>--> <img class="img-fluid pr-1" src="\assets\v2\img\mom-attendance.png" alt="Digital Attendance" /> Digital Attendance  <span class="d-none">Digital&nbsp;Attendance</span></a>
        </li>
        <li id="sideBarSettings" *ngIf="userRole ==1" [routerLinkActive]="['active']" (click)="SubmenuShow5 = !SubmenuShow5">
          <a><img class="img-fluid pr-1" src="\assets\v2\img\setting-icon.png" alt="Settings" /> Settings <span class="d-none">Settings</span> </a>
          <ul class="nav child_menu show-m" [ngClass]="{'show-m': SubmenuShow5, 'hide-m': !SubmenuShow5}">
            <li [routerLinkActive]="['current-page']"><a routerLink="/meetingtype" title="Metting Type">Meeting Type</a></li>
            <li [routerLinkActive]="['current-page']"><a routerLink="/meetinglocation" title="Meeting Location">Meeting Location</a></li>
            <li [routerLinkActive]="['current-page']"><a routerLink="/meetingroom" title="Metting Room">Meeting Room</a></li>
            <li [routerLinkActive]="['current-page']"><a routerLink="/usermaster" title="Metting Type">User</a></li>
          </ul>
        </li>
        <li id="sideBarReport"  *ngIf="userRole ==1"[routerLinkActive]="['active']" (click)="SubmenuShow7 = !SubmenuShow7;SubmenuShow5=false;">
          <a routerLink="/report"><img class="img-fluid pr-1" src="\assets\v2\img\report-icon.png" alt="Report" /> Report  <span class="d-none">Report</span></a>
        </li>
        <li [routerLinkActive]="['active']" (click)="SubmenuShow6 = !SubmenuShow6">
          <!--<a routerLink="/testmodal"><i class="las la-plus"></i> New Meeting Minutes </a>-->
          <a class="d-none"><i class="las la-plus" title="New Meeting Minutes"></i> New Meeting Minutes </a>
          <ul class="nav child_menu show-m" [ngClass]="{'show-m': SubmenuShow6, 'hide-m': !SubmenuShow6}">
            <li [routerLinkActive]="['current-page']"><a routerLink="/sladashboard/general">My Dashboard</a></li>
            <li [routerLinkActive]="['current-page']"><a routerLink="/sladashboard/report">Meeting Minutes</a></li>
            <li [routerLinkActive]="['current-page']"><a routerLink="/sladashboard/report">Action Points</a></li>
            <li [routerLinkActive]="['current-page']"><a routerLink="/sladashboard/report">Digital Attendance</a></li>

          </ul>
        </li>
      
      </ul>
    </div>

</div>
  </div>
  <!-- /sidebar menu -->
</div>
